import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    data: StatementListItem,
}

const StatementListItem: React.FC<Props> = ({ data }) => {
    const theme = useTheme();
    const itemStyle = (textColour: string) => css`
        color: ${textColour || theme.colours.black};
        font-family: ${theme.fonts.figtree} !important;
        font-size: 25px;
        font-weight: ${theme.fonts.weights.medium};
        max-width: 368px;
        text-align: center;
        white-space: pre-wrap;

        ${theme.breakpoints.only('lg')} {
            font-size: 22px;
            max-width: 320px;
        };

        ${theme.breakpoints.down('xs')} {
            font-size: 22px;
            max-width: 320px;
        };
    `;

    return (
        <p css={itemStyle(data.textColour)}>{data.text}</p>
    );
}

export default StatementListItem;
